import SectionPanel from "components/homepage/SectionPanel/SectionPanel";
import { RequestStatus } from "hooks/useRequest";
import { SettlementMessageModelTransformed } from "models/detailedSystemPrices/settlementModels";
import DateFilterModel from "models/filterModels/dateFilterModel";
import { SystemPriceModel } from "models/systemSellAndBuyPrices/systemSellAndBuyPricesModel";
import React from "react";
import { DataOrErrored } from "utils/dataOrErrored";
import routeConstants from "utils/routeConstants";

import SystemSellBuyPricesContent from "./SystemSellBuyPricesContent/SystemSellBuyPricesContent";

export type SystemSellBuyPriceData = {
  settlementMessages: DataOrErrored<SettlementMessageModelTransformed[]>;
  systemPrices: DataOrErrored<SystemPriceModel[]>;
  systemPricesDateFilter: DateFilterModel;
} | null;

interface Props {
  requestStatus: RequestStatus;
  data: SystemSellBuyPriceData;
  lastRefreshedDate?: Date;
}

const SystemSellBuyPrices: React.FC<Props> = ({
  requestStatus,
  data,
  lastRefreshedDate,
}) => (
  <SectionPanel
    testId="system-sell-buy-prices"
    title="System Buy / Sell Prices"
    description={
      <>
        <p>
          The indicative price calculation is published 15 minutes after the
          effective Settlement Period based on parameters available at the time
          the calculations were run.
        </p>
        <p>
          System Buy/Sell Prices is displaying the indicative £/MWh for a
          settlement period. It is derived from Bid-Offer Acceptances, BSAD and
          Market Index Data.
        </p>
        <p>
          Net Imbalance Volume is the net imbalance volume (in MWh) of the total
          system for a given Settlement Period. It is derived by netting Buy and
          Sell Actions in the Balancing Mechanism. Where the NIV is positive,
          the system is short and would normally result in the SO accepting
          Offers to increase generation/decrease consumption.
        </p>
      </>
    }
    link={{
      text: "See full graph",
      href: routeConstants.systemPrices,
    }}
    requestStatus={requestStatus}
    data={data}
    lastRefreshedDate={lastRefreshedDate}
  >
    {({
      systemPrices,
      settlementMessages,
      systemPricesDateFilter,
    }): React.ReactNode => (
      <SystemSellBuyPricesContent
        settlementMessages={settlementMessages}
        systemPrices={systemPrices}
        systemPricesDateFilter={systemPricesDateFilter}
      />
    )}
  </SectionPanel>
);

export default SystemSellBuyPrices;
